import { render } from "./Select.vue?vue&type=template&id=8f40db14&scoped=true"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import "./Select.vue?vue&type=style&index=0&id=8f40db14&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8f40db14"

export default script